import { defineStore } from 'pinia'

interface FeatureFlagsResponse {
  toggles: any[]
}

export const useFeatureFlagsStore = defineStore('featureFlags', {
  state: () => ({
    isFetched: false,
    flags: {
      toggles: [] as any[]
    }
  }),
  actions: {
    setFeatureFlags(flags: any) {
      if (Array.isArray(flags)) {
        this.flags.toggles = flags
      } else {
        this.flags = flags
      }
    },
    async fetchFeatureFlags() {
      const data = await $fetch<FeatureFlagsResponse>('/nuxt-api/feature-flags')

      this.setFeatureFlags(data.toggles)
      this.isFetched = true

      return data
    }
  }
})
